export const LOGOUT_BUTTON_TEST_ID = 'logout-button';
export const LOGOUT_ICON_TEST_ID = 'logout-icon';
